import { render, staticRenderFns } from "./LinkInventoryItemTable.vue?vue&type=template&id=79677351&scoped=true"
import script from "./LinkInventoryItemTable.vue?vue&type=script&lang=ts"
export * from "./LinkInventoryItemTable.vue?vue&type=script&lang=ts"
import style0 from "./LinkInventoryItemTable.vue?vue&type=style&index=0&id=79677351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79677351",
  null
  
)

export default component.exports